import { Icon, IconProps } from '@chakra-ui/react';
import colors from 'src/theme/colors';

export default function RightArrow(props: Omit<IconProps, 'css'>) {
  return (
    <Icon width="15px" height="10px" color={colors.white} {...props}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 10">
        <path
          opacity=".8"
          d="m9.5 1 4 4m0 0-4 4m4-4h-12"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
}
